export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-2xl">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>全网热播</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              蘑菇影视
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-600 mt-1">
                高清免费在线观影平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
              蘑菇影视官网首页入口，汇聚海量电影、电视剧、综艺、动漫资源，提供全高清画质在线播放体验。
              每日更新热门内容，支持手机与电脑多端访问，无需下载即点即看，播放流畅不缓冲。
              无论是最新院线大片还是经典怀旧剧集，都能在这里找到你的观影所爱。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">每日更新 精彩不断档</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">全高清画质 流畅不缓冲</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600">手机电脑多端同步访问</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即开始观影
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3 border border-secondary-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 font-medium text-sm rounded-md transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line mr-2"></i>
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20golden%20light%20rays%20streaming%20through%20a%20dark%20theater%20space%2C%20floating%20film%20strips%20and%20subtle%20geometric%20shapes%2C%20elegant%20and%20artistic%20movie%20atmosphere%2C%20rich%20amber%20and%20coral%20color%20tones%2C%20minimalist%20abstract%20design%20with%20depth%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20editorial%20style&width=960&height=720&seq=hero-movie-2026&orientation=landscape"
                alt="蘑菇影视 - 高清免费在线观影平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}